import { Component } from 'react';
import { connect } from 'react-redux';
import Downshift from 'downshift';
import queryString from 'query-string';
import styled from 'styled-components';
import {
  PopoverItem,
  PopoverMenu,
  PopoverContainer,
  PopoverItemButton,
} from 'ui/popover';
import find from 'lodash/find';
import { searchPlaceContacts } from 'api/places';
import { withTranslation } from 'react-i18next';

const Input = styled.input`
  border: 0;
  outline: none;
  padding: 0;
  margin: 0;
  background-color: transparent;
  width: 100%;
  max-width: 100%;

  &::placeholder {
    color: ${({ theme }) => theme.textLighter};
  }
`;

class ContactSearchDropdownInput extends Component {
  state = {
    inputValue: '',
    searchStatuses: {},
    searchResults: {},
  };

  static defaultProps = {
    focusOnMount: true,
  };

  componentDidMount() {
    const { focusOnMount } = this.props;

    if (focusOnMount) {
      this.input.focus();
    }
  }

  handleInputChange = async (search, ...args) => {
    this.setState({ inputValue: search || '' });

    if ((search || '').length < 2) {
      return;
    }

    this.setState({
      searchStatuses: {
        ...this.state.searchStatuses,
        [search]: 'pending',
      },
    });

    try {
      const { selectedPlaceId } = this.props;

      const { result, entities } = await searchPlaceContacts(
        selectedPlaceId,
        queryString.stringify({
          'filter[search]': search,
        }),
      );

      this.setState({
        searchStatuses: {
          ...this.state.searchStatuses,
          [search]: 'done',
        },
        searchResults: {
          ...this.state.searchResults,
          [search]: result
            .map(id => entities.users[id])
            .filter(({ canTalk }) => canTalk),
        },
      });
    } catch (e) {
      this.setState({
        searchStatuses: {
          ...this.state.searchStatuses,
          [search]: 'stalled',
        },
        searchResults: {
          ...this.state.searchResults,
          [search]: null,
        },
      });
    }
  };

  getItemsFromSearch = search => {
    const { members } = this.props;
    const { searchResults } = this.state;

    if (!searchResults[search]) {
      return [];
    }

    return (searchResults[search] || []).filter(
      ({ id }) => !find(members, member => member.id === id),
    );
  };

  handleSelectMember = member => {
    this.setState({ inputValue: '' }, () => this.props.onChange(member));
  };

  render() {
    const { inputValue } = this.state;
    const { t } = this.props;
    return (
      <Downshift
        inputValue={inputValue}
        onChange={this.handleSelectMember}
        onInputValueChange={this.handleInputChange}
        onOuterClick={() => this.setState({ inputValue: '' })}
        itemToString={i => i && i.displayName}
        render={({
          getInputProps,
          getItemProps,
          isOpen,
          inputValue,
          highlightedIndex,
        }) => (
          <div
            style={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            <Input
              {...getInputProps({
                placeholder: t('contactSearchInput'),
              })}
              ref={c => (this.input = c)}
            />
            {isOpen && this.getItemsFromSearch(inputValue).length > 0 && (
              <PopoverContainer>
                <PopoverMenu>
                  {this.getItemsFromSearch(inputValue).map((item, index) => (
                    <PopoverItem key={index}>
                      <PopoverItemButton
                        {...getItemProps({ item })}
                        isHighlighted={highlightedIndex === index}
                      >
                        {item.displayName}
                      </PopoverItemButton>
                    </PopoverItem>
                  ))}
                </PopoverMenu>
              </PopoverContainer>
            )}
          </div>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  selectedPlaceId: state.ui.selectedPlaceId,
});

export default connect(mapStateToProps)(
  withTranslation('conversationDetails')(ContactSearchDropdownInput),
);
